import React from "react";
import { Alert, Box } from "@mui/material";
import { getVisitWarningSeverityStyles } from "~/utils/visitsHelper";
import { VisitOrResourceWarningLabel } from "@caredna-marlin/utils/warnings/warnings-helper"

type Props = {
  labels: VisitOrResourceWarningLabel[];
};

const VisitWarningLabel: React.FC<Props> = ({labels}) => {

  if (!labels.length) return null;

  const sorted = labels.sort((a, b) => b.severity - a.severity)

  return (
    <Box sx={{ my: 2, maxHeight: 200, overflowY: "auto" }}>
      {sorted.map((label, idx) => {
        const { backgroundColor, color } = getVisitWarningSeverityStyles(label.severity);
        return (
          <Alert
            key={idx}
            icon={false}
            style={{ backgroundColor, color, margin: 2 }}
          >
            {label.warning}
          </Alert>
        );
      })}
    </Box>
  );
};

export default VisitWarningLabel;
